export enum LocationProxyEvent {
  idle,
  sending,
  error
}
